<script>
import Layout from "@layouts/form";
import ContratoRenovacao from "@forms/ContratoRenovacao";

export default {
  page: {
    title: "Detalhes | Contrato Renovação"
  },
  components: {
    Layout,
    ContratoRenovacao
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Contrato Renovação",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Contrato",
          href: "/Contrato"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ContratoRenovacao :editable="editable"></ContratoRenovacao>
    </div>
  </Layout>
</template>
